export const setPricelistList = (state, payload) => {
	state.pricelistList = payload;
}

export const setPricelistEdit = (state, payload) => {
	state.pricelistEdit = payload.obj;
}

export const setPriceTableAllSelected = (state, payload) => {

	state.undefinedImport = [];

	for( var x in state.priceTableAll ) {
		//console.log( state.priceTableAll[x].pli_pricing_table );
	}

	for (var k in state.priceTableAllSelected) {
		for (var m in state.priceTableAll) {
			if (state.priceTableAllSelected[k].pli_code == state.priceTableAll[m].pli_code && state.priceTableAllSelected[k].pli_pricing_table == state.priceTableAll[m].pli_pricing_table) {
				state.priceTableAll[m] = state.priceTableAllSelected[k];
			}
		}
	}
	var filterAdditionsDisplay = [];
	state.priceTableAllSelected = [];
	for (var k in state.priceTableAll) {
		//console.log( state.priceTableAll[k].pli_pricing_table );
		if (state.priceTableAll[k].pli_pricing_table == payload) {
			//console.log('here');
			filterAdditionsDisplay.push({ pli_id: state.priceTableAll[k].pli_id, pli_pricing_table: state.priceTableAll[k].pli_pricing_table, pli_code: state.priceTableAll[k].pli_code, pli_description: state.priceTableAll[k].pli_description, pli_filter: false, pli_price: parseFloat(state.priceTableAll[k].pli_price).toFixed(2), pli_new_price: parseFloat(state.priceTableAll[k].pli_new_price).toFixed(2), pli_uom: state.priceTableAll[k].pli_uom, pli_pricing_table: state.priceTableAll[k].pli_pricing_table });
		}
	}

	state.priceTableAllSelected = filterAdditionsDisplay;
}

export const fncPopulatePricingTable = (state, payload) => {
	/*var objPriceTable = [{ text: 'Select Table', display: true}];
	var checkPrice = [];
	for (var k in payload) {
		if (checkPrice.indexOf(payload[k].pli_pricing_table) === -1) {
			checkPrice.push(payload[k].pli_pricing_table);
		}
	}
	// checkPrice.sort();
    var firstTable = [];
	var n = 0;
	for (var p in checkPrice) {
		// var pricetableItem = { text: checkPrice[p] }
		//objPriceTable.push(pricetableItem);
		if (n == 0) {
			objPriceTable.push({ text: checkPrice[p], display: false });
		} else {
			objPriceTable.push({ text: checkPrice[p], display: false });
		}
		n++;
	}
	state.priceTableList = objPriceTable;*/
	var filterAdditions = [];
	var filterAdditionsDisplay = [];
	for (var k in payload) {
		filterAdditions.push({ pli_id: payload[k].pli_id, pli_code: payload[k].pli_code, pli_description: payload[k].pli_description, pli_filter: false, pli_price: parseFloat(payload[k].pli_price).toFixed(2), pli_new_price: parseFloat(payload[k].pli_price).toFixed(2), pli_uom: payload[k].pli_uom, pli_pricing_table: payload[k].pli_pricing_table });
		if (payload[k].pli_pricing_table == state.priceTableList[0].text) {
			filterAdditionsDisplay.push({ pli_id: payload[k].pli_id, pli_pricing_table: payload[k].pli_pricing_table, pli_code: payload[k].pli_code, pli_description: payload[k].pli_description, pli_filter: false, pli_price: parseFloat(payload[k].pli_price).toFixed(2), pli_new_price: parseFloat(payload[k].pli_price).toFixed(2), pli_uom: payload[k].pli_uom, pli_pricing_table: payload[k].pli_pricing_table });
		}
	}
	state.priceTableAll = filterAdditions;
	state.priceTableAllSelected = filterAdditionsDisplay;

}

export const fncFilterPrices = (state, payload) => {
	if( payload.action.action !== undefined ) {
		var percentage = ( parseFloat(payload.percentage) / 100 );
		for( var k in state.priceTableAllSelected ) {
			if (payload.priceList === state.priceTableAllSelected[k].pli_pricing_table  ) {
				var fValue = state.priceTableAllSelected[k].pli_new_price * percentage;
				if( payload.action.action == 'increase' ) {
					var newPrice = parseFloat(state.priceTableAllSelected[k].pli_new_price) + parseFloat(fValue);
				} else if( payload.action.action == 'decrease' ) {
					var newPrice = parseFloat(state.priceTableAllSelected[k].pli_new_price) - parseFloat(fValue);
				}
				if( payload.items.action === undefined ) {
					state.priceTableAllSelected[k].pli_new_price = parseFloat(newPrice).toFixed(2);
				} else if (payload.items.action === 'selected' && state.priceTableAllSelected[k].pli_filter === true ) {
					state.priceTableAllSelected[k].pli_new_price = parseFloat(newPrice).toFixed(2);
				} else if (payload.items.action === 'unselected' && state.priceTableAllSelected[k].pli_filter === false ) {
					state.priceTableAllSelected[k].pli_new_price = parseFloat(newPrice).toFixed(2);
				}
			}
		}
	}
	if (payload.rounding !== undefined) {
		if ( payload.rounding == 'roundup_number' ) {
			for (var k in state.priceTableAllSelected) {
				if (payload.priceList === state.priceTableAllSelected[k].pli_pricing_table) {
					var newPrice = state.priceTableAllSelected[k].pli_new_price;
					state.priceTableAllSelected[k].pli_new_price = Math.ceil(parseFloat(newPrice)).toFixed(2);
				}
			}
		} else if (payload.rounding == 'rounddown_number' ) {
			for (var k in state.priceTableAllSelected) {
				if (payload.priceList === state.priceTableAllSelected[k].pli_pricing_table) {
					var newPrice = state.priceTableAllSelected[k].pli_new_price;
					state.priceTableAllSelected[k].pli_new_price = Math.floor(parseFloat(newPrice)).toFixed(2);
				}
			}
		} else if (payload.rounding == 'roundup_decimal' ) {
			for (var k in state.priceTableAllSelected) {
				if (payload.priceList === state.priceTableAllSelected[k].pli_pricing_table) {
					var newPrice = parseFloat(state.priceTableAllSelected[k].pli_new_price);
					newPrice = Math.ceil(parseFloat(newPrice) * 10) / 10;
					state.priceTableAllSelected[k].pli_new_price = parseFloat(newPrice).toFixed(2);
				}
			}
		} else {
			for (var k in state.priceTableAllSelected) {
				if (payload.priceList === state.priceTableAllSelected[k].pli_pricing_table) {
					var newPrice = state.priceTableAllSelected[k].pli_new_price;
					newPrice = Math.floor(parseFloat(newPrice) * 10) / 10;
					state.priceTableAllSelected[k].pli_new_price = parseFloat(newPrice).toFixed(2);
				}
			}
		}
	}
}

export const fncResetFilterPrices = (state, payload) => {
	for (var k in state.priceTableAll) {s
		for ( var s in state.priceTableAllSelected ) {
			if (state.priceTableAllSelected[s].pli_id == state.priceTableAll[k].pli_id) {
				state.priceTableAll[k] = state.priceTableAllSelected[s];
			}
		}
	}
	var filterAdditionsDisplay = [];
	var filterAdditions = [];
	for (var k in state.priceTableAll) {
		filterAdditions.push({ pli_id: state.priceTableAll[k].pli_id, pli_code: state.priceTableAll[k].pli_code, pli_description: state.priceTableAll[k].pli_description, pli_filter: false, pli_price: parseFloat(state.priceTableAll[k].pli_price).toFixed(2), pli_new_price: parseFloat(state.priceTableAll[k].pli_price).toFixed(2), pli_uom: state.priceTableAll[k].pli_uom, pli_pricing_table: state.priceTableAll[k].pli_pricing_table });
		if (state.priceTableAll[k].pli_pricing_table == payload) {
			filterAdditionsDisplay.push({ pli_id: state.priceTableAll[k].pli_id, pli_code: state.priceTableAll[k].pli_code, pli_description: state.priceTableAll[k].pli_description, pli_filter: false, pli_price: parseFloat(state.priceTableAll[k].pli_price).toFixed(2), pli_new_price: parseFloat(state.priceTableAll[k].pli_price).toFixed(2), pli_uom: state.priceTableAll[k].pli_uom, pli_pricing_table: state.priceTableAll[k].pli_pricing_table });
		}
	}
	state.priceTableAll = filterAdditions;
	state.priceTableAllSelected = filterAdditionsDisplay;
    /*
    var filterAdditions = [];
	var filterAdditionsDisplay = [];
	for (var k in payload) {
		filterAdditions.push({ pli_code: payload[k].pli_code, pli_description: payload[k].pli_description, pli_filter: false, pli_price: parseFloat(payload[k].pli_price).toFixed(2), pli_new_price: parseFloat(payload[k].pli_price).toFixed(2), pli_uom: payload[k].pli_uom, pli_pricing_table: payload[k].pli_pricing_table });
		if (payload[k].pli_pricing_table == state.priceTableList[0].text ) {
			filterAdditionsDisplay.push({ pli_code: payload[k].pli_code, pli_description: payload[k].pli_description, pli_filter: false, pli_price: parseFloat(payload[k].pli_price).toFixed(2), pli_new_price: parseFloat(payload[k].pli_price).toFixed(2), pli_uom: payload[k].pli_uom, pli_pricing_table: payload[k].pli_pricing_table });
		}
	}
	state.priceTableAll = filterAdditions;
	state.priceTableAllSelected = filterAdditionsDisplay;
    */



	/*var filterAdditions = [];
	for( var k in state.priceTableAll ) {
		var singleRow = state.priceTableAll[k];
		singleRow.pli_filter = false;
		singleRow.pli_new_price = parseFloat(singleRow.pli_price).toFixed(2);
		filterAdditions.push( singleRow );
	}
	state.priceTableAll = filterAdditions;*/

}

export const setPriceTableDetails = (state, payload) => {
	state.priceTableDetails = payload;
}

export const fncEmptyPricelistEditDetails = (state, payload) => {
	state.pricelistEdit = '';
}

export const fncSetPricelistEditDetails = (state, payload) => {
	var filterAdditions = [];
	var filterAdditionsDisplay = [];
	var objPriceTable = [];
	var checkPrice = [];
	// var firstTable = payload.objPlistItems[0].pli_pricing_table;
	// var firstTable = state.priceTableList[0].text;
	for (var k in payload.objPlistItems) {
		/*if (payload.objPlistItems[k].pli_pricing_table == firstTable ) {
			filterAdditionsDisplay.push(payload.objPlistItems[k]);
		}*/
		var singleRow = payload.objPlistItems[k];
		if (checkPrice.indexOf(singleRow.pli_pricing_table) === -1) {
			checkPrice.push(singleRow.pli_pricing_table);
		}
		singleRow.pli_filter = false;
		singleRow.pli_new_price = parseFloat(singleRow.pli_price).toFixed(2);
		var toPush = { "pli_id": singleRow.pli_id, "pli_code": singleRow.pli_code, "pli_description": singleRow.pli_description, "pli_filter": singleRow.pli_filter, "pli_price": singleRow.pli_price, "pli_new_price": singleRow.pli_new_price, "pli_uom": singleRow.pli_uom, "pli_pricing_table": singleRow.pli_pricing_table };
		filterAdditions.push(toPush);
	}
	var firstTable = [];
	var n = 0;
	for (var p in checkPrice) {
		objPriceTable.push({ text: checkPrice[p], display: false });
		n++;
	}
	state.priceTableList = objPriceTable;
	state.priceTableAllSelected = [];
	//state.priceTableAllSelected = filterAdditionsDisplay;
	state.priceTableAll = filterAdditions;
	payload.objPlist.pl_active = payload.objPlist.pl_active == 0 ? false : true;
	payload.objPlist.pl_is_default = payload.objPlist.pl_is_default == 0 ? false : true;
	payload.objPlist.pl_is_cost = payload.objPlist.pl_is_cost == 0 ? false : true;
	state.pricelistEdit = payload.objPlist;
}

export const fncSetPriceTables = (state, payload) => {
}

export const fncEmptyPricelists = (state, payload) => {
	state.pricelistList = [];
	state.priceTableList = [];
}

export const fncSetPricelistImport = (state, payload) => {
	state.undefinedImport = [];
	state.nonImport = [];
	var addedFakeCodes = [];
	var importType = 'normal';
	var importRows = payload.rows[0].split(',');

	if (importRows.length > 2 ) {
        importType = 'matrix'
	}
	if (importType == 'matrix') {
		var parsed_pt = [];
		var rows = payload.rows;
		var x_axis = rows[0].split(",");
		for (var r = 1; r < rows.length; r++) {
			var row = rows[r];
			var values = row.split(",");
			for (var v = 1; v < values.length; v++) {
				var code = (x_axis[v] + values[0]).toString().replace(/[\n\r]+/g, '').trim();
				var price = values[v].toString().replace(/[\n\r]+/g, '').trim() == "" ? 0.00 : parseFloat(values[v]);
				parsed_pt.push({code: code, price: price });
			}
		}
		for (var p in parsed_pt) {
			if (parsed_pt[p].price != '0') {
				var importPrice = parseFloat(parsed_pt[p].price).toFixed(2);
				var importCode = parsed_pt[p].code;
				/*for (var s in state.priceTableAll) {
					if (state.priceTableAll[s].pli_code == importCode && state.priceTableAll[s].pli_pricing_table == payload.priceTable) {
						state.priceTableAll[s].pli_new_price = importPrice;
					} else if( addedFakeCodes.indexOf( parsed_pt[p].code ) == -1 && state.priceTableAll[s].pli_pricing_table == payload.priceTable ) {
						addedFakeCodes.push( parsed_pt[p].code );
						state.undefinedImport.push( parsed_pt[p] );
					}
				}*/
				for (var s in state.priceTableAllSelected) {

					if (state.priceTableAllSelected[s].pli_code.trim() == importCode.trim() && state.priceTableAllSelected[s].pli_pricing_table == payload.priceTable) {
						if( parseFloat(importPrice).toFixed(2) == parseFloat(state.priceTableAllSelected[s].pli_price).toFixed(2) ) {
							state.nonImport.push( parsed_pt[p] );
						} else {
							state.priceTableAllSelected[s].pli_new_price = importPrice;
						}
					} else if( addedFakeCodes.indexOf( parsed_pt[p].code ) == -1 && state.priceTableAllSelected[s].pli_pricing_table == payload.priceTable ) {
						addedFakeCodes.push( parsed_pt[p].code );
						state.undefinedImport.push( parsed_pt[p] );
					}
				}
			}
		}
	} else {

		for (var k in payload.rows) {
			//if (k != 0) {
				var splitObj = payload.rows[k].split(',');

				if (splitObj[0] != '' ) {
					var code = splitObj[0];
					var pliPrice = parseFloat(splitObj[1]).toFixed(2);

					/*for (var s in state.priceTableAll) {
						if (state.priceTableAll[s].pli_pricing_table == payload.priceTable && state.priceTableAll[s].pli_code == code) {
							state.priceTableAll[s].pli_new_price = pliPrice;
						} else if( addedFakeCodes.indexOf( code ) == -1 && state.priceTableAll[s].pli_pricing_table == payload.priceTable ) {
							addedFakeCodes.push( code );
							state.undefinedImport.push( { code: code, price: pliPrice } );
						}
					}*/
					for (var s in state.priceTableAllSelected) {

						if (state.priceTableAllSelected[s].pli_pricing_table == payload.priceTable && state.priceTableAllSelected[s].pli_code == code) {

							if( parseFloat(importPrice).toFixed(2) == parseFloat(state.priceTableAllSelected[s].pli_price).toFixed(2) ) {
								state.nonImport.push( { code: code, price: pliPrice } );
							} else {
								state.priceTableAllSelected[s].pli_new_price = pliPrice;
							}
						} else if( addedFakeCodes.indexOf( code ) == -1 && state.priceTableAllSelected[s].pli_pricing_table == payload.priceTable ) {
							addedFakeCodes.push( code );
							state.undefinedImport.push( { code: code, price: pliPrice } );
						}
					}
				}
			//}
		}
	}

  /*var snackDetails = { color: 'success', message: 'The pricelist items has been successfully imported', display: true };
  state.globalSnackDisplay = '';
  setTimeout(function(){
    state.globalSnackDisplay = snackDetails.display;
    state.globalSnackColor = snackDetails.color;
    state.globalSnackMessage = snackDetails.message;
  }, 1000)*/

  alert('The pricelist items has been successfully imported');

  state.importingData = false;

}

export const fncIsLibraryUpdate = (state, payload) => {
	state.isLibraryUpdate = true;

	var libraryStats = [];

	for( var l in payload.diff ) {

		for( var t in payload.diff[l] ) {

			var name = payload.diff[l][t].replace('|',' - ');

			if( l == 'additions' ) {
				libraryStats.push({ name: name, type: 'Addition' });
			} else if( l == 'deletions' ) {
				libraryStats.push({ name: name, type: 'Deletion' });
			}
		}
	}

	state.libraryDetails = libraryStats;
}

export const fncIsLibraryUpdateFalse = (state, payload) => {
	state.isLibraryUpdate = false;
}

export const fncLibraryDetails = (state, payload) => {
	state.libraryDetails = payload;
}

export const setEmptyPriceTableAllSelected = (state, payload) => {
	state.priceTableAllSelected = payload;
}

export const setLibraryLoading = (state, payload) => {
	state.libraryLoading = payload;
}

export const setImportingData = (state, payload) => {
  state.importingData = payload;
}
